type Insets = {
  top: number;
  right: number;
  bottom: number;
  left: number;
};

type TelegramWebApp = {
  ready?: () => void;
  expand?: () => void;
  disableVerticalSwipes?: () => void;
  enableClosingConfirmation?: () => void;
  onEvent?: (name: string, callback: () => void) => void;
  contentSafeAreaInset?: Insets;
};

declare global {
  interface Window {
    Telegram?: {
      WebApp?: TelegramWebApp;
    };
  }
}

export type TelegramLifecycle = {
  onActivated: (callback: () => void) => void;
  onDeactivated: (callback: () => void) => void;
};

function applyInsets(insets?: Insets): void {
  if (!insets) return;

  const root = document.documentElement;
  root.style.setProperty('--tg-content-safe-area-inset-top', `${insets.top}px`);
  root.style.setProperty('--tg-content-safe-area-inset-right', `${insets.right}px`);
  root.style.setProperty('--tg-content-safe-area-inset-bottom', `${insets.bottom}px`);
  root.style.setProperty('--tg-content-safe-area-inset-left', `${insets.left}px`);
}

export function initializeTelegram(): TelegramLifecycle {
  const webApp = window.Telegram?.WebApp;

  webApp?.ready?.();
  webApp?.expand?.();
  webApp?.disableVerticalSwipes?.();
  webApp?.enableClosingConfirmation?.();
  applyInsets(webApp?.contentSafeAreaInset);
  webApp?.onEvent?.('contentSafeAreaChanged', () => applyInsets(webApp.contentSafeAreaInset));

  return {
    onActivated(callback) {
      webApp?.onEvent?.('activated', callback);
      window.addEventListener('focus', callback);
    },
    onDeactivated(callback) {
      webApp?.onEvent?.('deactivated', callback);
      window.addEventListener('blur', callback);
    },
  };
}
